import { connect } from 'react-redux';
import RefineSearchView from './RefineSearch';

import {
    getNumberOfAppliedAvailabilityRefinements,
    getNumberOfAppliedGenderRefinements,
    getNumberOfAppliedHoursRefinements,
    getNumberOfAppliedLanguageRefinements,
    getNumberOfAppliedMiscRefinements,
    getNumberOfAppliedRefinements,
    getSearchParameters,
} from '../../../state';

export function mapStateToProps(state, ownProps) {
    const numberOfAppliedRefinements = getNumberOfAppliedRefinements(state);
    const numberOfAppliedAvailabilityRefinements = getNumberOfAppliedAvailabilityRefinements(state);
    const numberOfAppliedGenderRefinements = getNumberOfAppliedGenderRefinements(state);
    const numberOfAppliedHoursRefinements = getNumberOfAppliedHoursRefinements(state);
    const numberOfAppliedLanguageRefinements = getNumberOfAppliedLanguageRefinements(state);
    const numberOfAppliedMiscRefinements = getNumberOfAppliedMiscRefinements(state);
    const parameters = getSearchParameters(state);

    const { totalCount: potentialMatches } = ownProps;

    return {
        ...parameters,
        numberOfAppliedAvailabilityRefinements,
        numberOfAppliedGenderRefinements,
        numberOfAppliedHoursRefinements,
        numberOfAppliedLanguageRefinements,
        numberOfAppliedMiscRefinements,
        numberOfAppliedRefinements,
        potentialMatches,
    };
}

export default connect(mapStateToProps, undefined)(RefineSearchView);
